export default "__VITE_ASSET__DExUrQPB__";